export default __webpack_public_path__ + "assets/ico_rule_off_black-9d50af92.svg";